'use client'

import clsx from 'clsx'
import Link from 'next/link'
import { useEffect, useState } from 'react'

export default function ScrollProgress() {
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        const handleScroll = () => {
            const content = document.getElementById("scroll-progress-container")

            if (!content) {
                return
            }

            const scrollPosition =
                document.body.scrollTop || document.documentElement.scrollTop

            var scrollProgress = Math.min(((scrollPosition) / (content.clientHeight - content.offsetTop * 5)), 1)

            setProgress(scrollProgress)
        }

        handleScroll()
        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const circumference = 2 * Math.PI * 24
    const dashArray = `${progress > 0.1 ? progress * circumference : 0}, ${circumference - (progress * circumference)}`

    if (progress > 0.99 || progress < 0.1) {
        return null
    }

    return (
        <Link
            href={progress > 0 ? '#post-header' : '#content'}
            className={"fixed bottom-4 lg:bottom-10 right-4 lg:right-10 w-12 h-12 transition-all rounded-full z-10"}
        >
            <svg width="48" height="48" className="-rotate-90 overflow-visible">
                <circle
                    cx="24"
                    cy="24"
                    r="23"
                    fill="transparent"
                    stroke="#ffffff"
                    strokeWidth="1.5"
                    strokeDasharray={dashArray}
                />
            </svg>

            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={clsx(
                    "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-transform",
                    progress > 0.1 ? 'rotate-180' : 'rotate-0'
                )}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z"
                    fill="white"
                />
            </svg>
        </Link>
    )
}
